"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceLinks = exports.substituteVars = exports.T = exports.Data = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const T = __importStar(require("./type"));
exports.T = T;
const utils_tsx_1 = require("../utils-tsx");
const Data = __importStar(require("./data"));
exports.Data = Data;
exports.substituteVars = (content, replaceVars, prefixVar = '\\${', suffixVar = '}') => {
    if (!replaceVars) {
        return content;
    }
    Object.entries(replaceVars).forEach(([k, v]) => {
        const wrappedKey = prefixVar + k + suffixVar;
        const rgp = new RegExp(wrappedKey, 'g');
        content = content.replace(rgp, v);
    });
    return content;
};
exports.replaceLinks = (content) => {
    return content.replace(/<a.*href="(.+)"[^>]*>(.+)<\/a>/, '<a onClick="javascript: redirectFunction(\'$1\')" href="javascript: void(0)">$2</a>');
};
exports.default = ({ fetchData = Data.getData, uuid, lang = 'en', isHtml = true, replaceVars, Loader = utils_tsx_1.Loader }) => {
    const [content, setContent] = react_1.useState(null);
    const [redirect, setRedirect] = react_1.useState(null);
    const clickHandler = (event) => {
        if (event) {
            const link = event.target.getAttribute('href');
            if (link && !link.match(/^http/)) {
                event.preventDefault();
                setRedirect(link);
            }
        }
    };
    if (redirect) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: redirect });
    }
    if (content === null) {
        fetchData(uuid, lang, isHtml).then(cms => {
            const { content } = cms;
            setContent(content);
        });
        return react_1.default.createElement(Loader, null);
    }
    const contentFinal = exports.substituteVars(content, replaceVars);
    if (isHtml) {
        return (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: contentFinal }, onClick: clickHandler }));
    }
    return react_1.default.createElement(react_1.default.Fragment, null, "content");
};
